import React, { useEffect, useState } from 'react'
import styles from './styles.module.css'
import useSubscriptionStore from '../SubscriptionStore'
import useEscapeKey from '../../../utils/useEscapeKey'

export default function SubscriptionAdded ({ onClose, handleCloseOnClick }) {
  const [isVisible, setIsVisible] = useState(false)
  const { setIsPaymentSuccessful } = useSubscriptionStore()

  // Trigger the slide-in effect when the component mounts
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setIsVisible(true)
    }, 1)
    return () => clearTimeout(timeoutId)
  }, [])

  const handleClose = e => {
    e.stopPropagation()
    setTimeout(() => {
      if (handleCloseOnClick) handleCloseOnClick()
    }, 250)
    setIsVisible(false)
  }

  useEscapeKey(e => handleClose(e))

  const handleSuccessful = e => {
    e.stopPropagation()
    setTimeout(() => {
      setIsVisible(false)
      if (onClose) onClose()
      setIsPaymentSuccessful(true)
    }, 250)
  }

  return (
    <div className={styles.modalBackdrop} onClick={handleClose}>
      <div
        className={styles.modalContent}
        style={{ transform: isVisible ? 'translateX(0)' : 'translateX(100%)' }}
        onClick={e => e.stopPropagation()}
      >
        <h1 className={styles.H1SubscriptionUpgraded}>Subscription added</h1>
        <p className={styles.PSubscriptionUpgraded}>
          You've added a people data subscription to your account. Click
          continue to return to the Datafiniti portal, where you'll now be able
          to view people records.
        </p>

        <button onClick={handleSuccessful} className={styles.continueButton}>
          Continue
        </button>
      </div>
    </div>
  )
}
